// extracted by mini-css-extract-plugin
export default {"container":"AboutContent_container__XKfH6"};